import { getOverride } from "@Light/override";
import React from "react";
import { ScaffoldContext } from "./context";
import { defaultScaffold } from "./default";
import { Scaffold } from "./scaffold";

export type ProviderProps = {
  scaffold?: Scaffold;
  children: React.ReactNode;
};

export function Provider({ scaffold, children }: ProviderProps) {
  const baseValue: Scaffold = scaffold ?? defaultScaffold;
  const override = getOverride();
  const value = override
    ? {
        ...baseValue,
        page: {
          ...baseValue.page,
          companyName: override.companyName ?? baseValue.page.companyName,
          legalEntityName:
            override.companyName ?? baseValue.page.legalEntityName,
          supportEmail: override.supportEmail ?? baseValue.page.supportEmail,
          brandMode: override.brandMode ?? baseValue.page.brandMode,
        },
      }
    : baseValue;

  return (
    <ScaffoldContext.Provider value={value}>
      {children}
    </ScaffoldContext.Provider>
  );
}
